import { tariff_icons } from './tariff-icons';
import { custom_tab_icons as custom_tab_icons_config } from './tab-icons';
import { heating_circuits_custom_icons } from './heating-circuits';
import { Socket } from 'console/shared/components/fields/icon/icons/socket';
import { Flame } from 'console/shared/components/features/animated-icons/flame';
import Pump from 'console/images/heating-circuit/pump.svg';
import RelayOff from 'console/images/heating-circuit/relay-off.svg';
import ThreeWay from 'console/images/heating-circuit/threeway-new.svg';
import { styled_tariff_icons } from './tariff-icons/dark-light-Icon';
export const custom_tab_icons = [
    ...custom_tab_icons_config,
    // max amount in z3k config 127
    // ...tariff_icons,
    // ...styled_tariff_icons,
];
export const heating_circuits_icons = [
    ...heating_circuits_custom_icons,
    ...tariff_icons,
    ...styled_tariff_icons,
];
//при добавлении новых иконок пишем сюда последний занятый id - 402
//в массив вписываем id главных иконок, только у которых есть similar
export const array_id_main_icons = [
    0, 1, 2, 3, 6, 7, 8, 9, 10, 15, 16, 17, 23, 29, 35, 41, 47, 53, 59, 65, 71, 77, 83,
    89, 95, 107, 113, 119, 125, 131, 137, 143, 149, 155, 161, 173, 179, 185, 191, 197,
    203, 209, 215, 221, 227, 233, 300, 302, 303, 305, 306, 309, 310, 311, 312, 313, 314,
    315, 316, 317, 318, 319, 320, 239, 240, 241, 242, 245, 243, 244,
];
//see IconForWebElement
export const web_element_icons = [
    ...heating_circuits_custom_icons.slice(0, 1),
    {
        id: 300,
        render: Socket,
        title: 'Розетка',
        paid: false,
        similar: [300, 374, 375, 376, 377, 378, 338],
    },
    {
        id: 301,
        render: Flame,
        title: 'Огонёк',
        paid: true,
    },
    {
        id: 302,
        render: Pump,
        title: 'Насос',
        paid: true,
        similar: [302, 379, 380, 381, 382, 383],
    },
    {
        id: 303,
        render: RelayOff,
        title: 'Реле',
        paid: true,
        similar: [303, 384, 385, 386, 387, 388],
    },
    {
        id: 304,
        render: ThreeWay,
        title: 'Трёхходовой кран',
        paid: true,
    },
    ...heating_circuits_custom_icons.slice(1),
    ...tariff_icons,
    ...styled_tariff_icons,
];
